export default import.meta.ROLLDOWN_FILE_URL_hxIdvfEh$$_uTfLd__KJww